(function ($, window, document) {
  $(document).ready(function () {
    if ($('.slider-navigation').length) {
      $('.slider-navigation li:first').addClass('active-step');
    }
  });

  //Window On Load function
  $(window).on("load", function () {
    // Smooth scroll on page load if URL has a hash
    if (window.location.hash) {
      let initialTarget = $(window.location.hash),
      headerHeight = $('header').outerHeight(true),
      sectionMarginTop = initialTarget.length ? parseInt(initialTarget.css('margin-top')) : 0,
      childMenuHeight = $('.child-page-menu').length ? $('.child-page-menu').outerHeight(true) : 0,
      wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0;
      if (initialTarget.length) {
        $('html, body').animate({
          scrollTop: initialTarget.offset().top - headerHeight - sectionMarginTop - wpAdminBar - childMenuHeight + 40
        }, 800); // Duration of scroll animation in milliseconds (800ms)
      }
    }

    $(".hamburger").on("click", function () {
      let expanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !expanded);
      $("header").toggleClass("active");
      $("body, html").toggleClass("overflow");

      $(".nav-link").each(function (index, ele) {
        const delay = 0.22 + index * 2 * 0.01;
        $(ele).css("transition-delay", delay + "s");
      });

      const delay = 0.26 + $(".nav-link").length * 2 * 0.01;

      $(".nav-cta").css("transition-delay", delay + "s");
    });

    if ($(window).innerWidth() < 1024) {
      $('#menu-primary-navigation .menu-item-has-children').click(function (e) {
        const target = $(e.target); // Cache the jQuery object
        
        // Check if the clicked element is an anchor tag that has a valid href
        if (target.is('a') && !(target.attr('href') === "#" || target.attr('href') === "")) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        let menuChild = $(this);

        if (!menuChild.hasClass('active') && menuChild.parent('#menu-primary-navigation').length) {
          $('.menu-item-has-children.active > .sub-menu').slideUp();
          $('.primary-navigation').removeClass("primary-menu-active");
          $('.menu-item-has-children.active').removeClass('active');
        }

        if (menuChild.children('.menu-wrapper').length) {
          menuChild.find('.menu-wrapper > .external-menu .menu-item').slideToggle();
          menuChild.find('.menu-wrapper > .sub-menu').slideToggle();
          menuChild.toggleClass('active');
        } else {
          menuChild.children('.sub-menu:not(> .menu-item-has-children)').slideToggle();
          menuChild.parent('#menu-primary-navigation').parents('nav').toggleClass("primary-menu-active");
          menuChild.toggleClass('active');
        }
      });
    }

    $(".scholar-tab").on("click", function () {
      $(".scholar-tab").removeClass("text-pa-red");
      $(this).addClass("text-pa-red");

      const tabYear = $(this).attr("data-year");
      $(".tab-scholars").addClass("hidden");
      $('.tab-scholars#year-' + tabYear).removeClass("hidden");
    });

    let searchTimeOut;
    $('.university-search').on('keydown', function (e) {
      if (e.which === 13) { // 13 is the Enter key code
        e.preventDefault(); // Prevent the default form submission
      }

      clearTimeout(searchTimeOut); // Clear any existing timeout

      // Set a new timeout to execute the search
      searchTimeOut = setTimeout(() => {
        let currentElement = $(this),
          searchVal = currentElement.val(),
          year = parseInt($('.university-slider-btn.text-pa-red').attr('data-year')),
          orderBy = currentElement.parents('.list-content').find('.sort-by-filter input[name="text-filter"]:checked').val(),
          order = currentElement.parents('.list-content').find('.sort-by-filter input[name="order"]:checked').val(),
          currentTabList = currentElement.parents('.list-content').find('.university-container'),
          currentListType = currentTabList.attr('data-list-type');

        searchFilter(searchVal, year, currentTabList, order, currentListType, orderBy);
      }, 300); // Increase timeout to 300ms for improved performance
    });

    $('.filter-cta').on('click', function () {
      $('.filter-container').fadeToggle();

      $('.filter-container .btn-container a').on('click', function (e) {
        e.preventDefault();
        let clickedElement = $(this),
          year = parseInt($('.university-slider-btn.text-pa-red').attr('data-year')),
          searchVal = $(clickedElement).parents('.list-content').find('.university-search').val(),
          currentTabList = $(clickedElement).parents('.list-content').find('.university-container'),
          currentListType = currentTabList.attr('data-list-type'),
          orderBy = $(clickedElement).parents('.sort-by-filter').find('input[name="text-filter"]:checked').val(),
          order = $(clickedElement).parents('.sort-by-filter').find('input[name="order"]:checked').val();
  
        searchFilter(searchVal, year, currentTabList, order, currentListType, orderBy);
        $('.filter-container').fadeOut();
      });
    });

    $(document).click(function (event) {
      if (!$(event.target).closest('.filter-container').length && !$(event.target).closest('.filter-cta').length) {
        $('.filter-container').fadeOut();
      }
    });

    function searchFilter(searchVal, year, currentTabList, order, currentListType, orderBy) {
      $.ajax({
        type: 'post',
        url: wp_ajax_data.ajax_url,
        data: {
          action: 'university_search',
          search: searchVal,
          year: year,
          order: order,
          list_type: currentListType,
          order_by: orderBy
        },
        success: function (response) {
          response ? $(currentTabList).html(response) : $(currentTabList).html('<li class="w-full text-center text-pa-red text-lg py-5"><span>No data found</span></li>');
        },
        error: function (xhr, status, error) {
          $(currentTabList).html('<li class="text-center text-pa-red text-lg py-5"><span>Something went wrong!</span></li>');
        },
      });
    }

    //function for global menu
    if ($(".global-menu").length) {
      let currentPageUrl = window.location.href;
      let href, title = '';
      const globalList = $(".global-menu li"),
        anchor = $(".global-menu li.first a");

      $(window).resize(function () {

        //function on remove class based on screen size
        if ($(window).innerWidth() > 995) {
          globalList.not(':first-child').each(function () {
            let currentElement = $(this);
            currentElement.css('display', 'block');
          });
        }
      });
      globalList.find("a").each(function () {
        var menuUrl = $(this).attr('href');

        // Compare the current page URL with the menu item URL
        if (currentPageUrl.indexOf(menuUrl) !== -1) {
          let currentElement = $(this);
          currentElement.addClass("text-pa-red");
          href = currentElement.parent().find('a').attr('href');
          title = currentElement.parent().find('a').attr('title');
        }
      });
      anchor.attr('href', href);
      anchor.text(title);

      if ($(".first").length) {
        //function to toggle menu dropdown and add class rotate
        $(".first").on('click', function (event) {
          event.preventDefault();

          if ($('.global-menu').hasClass('menu-active')) {
            $('.global-menu').removeClass('menu-active');
            globalList.filter(':not(:first-child)').slideUp('slow');
          } else {
            globalList.filter(':not(:first-child)').slideDown('slow');
            $('.global-menu').addClass('menu-active');
          }
        });
      }
    }

    // content link video popup modal
    $('.thinking-slider-wrapper .modal-link a').click(function (e) {
      e.preventDefault();
      let linkClicked = $(this),
        videoUrl = linkClicked.attr('href'),
        linkTarget = linkClicked.attr('target'),
        haveModal = linkClicked.parents('.thinking-slider-wrapper').find('.video-modal-container'),
        clonedModal = "",
        currentUrl = window.location.href.split('?')[0],  // Get the base URL without any query params
        urlParams = new URLSearchParams(window.location.search);
        urlParams.set('video_id', linkClicked.attr('data-video-id'));  // If it exists, it will be updated; otherwise, it will be added
  
        let newUrl = currentUrl + (urlParams.toString() ? '?' + urlParams.toString() : '');
        
      if (haveModal && videoUrl.indexOf('wistia') != -1) {
        haveModal.find('iframe').attr('src', videoUrl);
        clonedModal = haveModal.clone();
        $('body').append(clonedModal);
        $(clonedModal).fadeIn(500);
        $('body').addClass('wistia-modal-active');
        window.history.pushState({ path: newUrl }, '', newUrl); // Update the browser's URL without reloading
      } else {
        if (videoUrl) {
          if (linkTarget === "_blank") {
            window.open(videoUrl, '_blank');
          } else {
            window.location.href = videoUrl;
          }
        }
      }
    });

    // Video popup modal
    $('.wistia-video-embeded').click(function (e) {
      e.preventDefault();
      let videoElement = $(this),
      haveModal = videoElement.find('.video-modal-container'),
      clonedModal = "",
      currentUrl = window.location.href.split('?')[0],  // Get the base URL without any query params
      urlParams = new URLSearchParams(window.location.search);
      urlParams.set('video_id', videoElement.attr('data-video-id'));  // If it exists, it will be updated; otherwise, it will be added

      let newUrl = currentUrl + (urlParams.toString() ? '?' + urlParams.toString() : '');

      if (haveModal && videoElement.attr('data-video-id') == haveModal.attr('id')) {
        clonedModal = haveModal.clone();
      } else if (videoElement.hasClass('btn')) {
        clonedModal = videoElement.parents('li').find('.video-modal-container.cta-video').clone();
      } else {
        clonedModal = videoElement.parents('.have-embed-video').find('.video-modal-container:not(.cta-video)').clone();
      }

      $('body').append(clonedModal);
      $(clonedModal).fadeIn(500);
      $('body').addClass('wistia-modal-active');

      window.history.pushState({ path: newUrl }, '', newUrl); // Update the browser's URL without reloading
    });

    // Check if the video_id parameter exists in the URL on page load
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('video_id')) {
      // Artificially create a click event and trigger it
      let videoId = urlParams.get('video_id'), // You might want to find the correct element based on the video_id
        videoLinkCta = $('.wistia-video-embeded[data-video-id="' + videoId + '"]').length ? $('.wistia-video-embeded[data-video-id="' + videoId + '"]') : $('.thinking-slider-wrapper .modal-link a[data-video-id="' + videoId + '"]');
      if (videoLinkCta.length) {
        let headerHeight = $('header').outerHeight(true),
          childMenuHeight = $('.child-page-menu').length ? $('.child-page-menu').outerHeight(true) : 0,
          wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0,
          sectionTop = videoLinkCta.parents('section').offset().top;

        $('html, body').animate({
          scrollTop: sectionTop - headerHeight - childMenuHeight - wpAdminBar
        }, 800);

        setTimeout(() => {
          videoLinkCta.triggerHandler('click'); // Trigger the click event on the matching CTA
        }, 1000);
      }
    }

    $(document).click(function (event) {
      videoModalClose(event);
    });

    function videoModalClose(event) {
      if (($(event.target).closest('.video-modal-container').length && !$(event.target).closest('.video-modal').length) || $(event.target).closest('.video-modal-close').length) {
        event.preventDefault();
        let currentUrl = window.location.href.split('?')[0],  // Get the base URL
        urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('video_id'); // Remove the 'video_id' parameter if it exists

        $(event.target).closest('.video-modal-container').remove();
        $('body').removeClass('wistia-modal-active');
        
        let updatedUrl = currentUrl + (urlParams.toString() ? '?' + urlParams.toString() : ''); // Reconstruct the URL without the video_id parameter
        window.history.pushState({ path: updatedUrl }, '', updatedUrl); // Update the browser's URL without reloading
      }
    }

    if ($('.image-and-content-with-show-more').length) {
      // Get min and max height of content
      $('.show-more-content').each(function (idx, element) {
        let contentArea = $(element).find('.content-area'),
          contentLineClamp = contentArea.attr('data-line-clamp'),
          contentMinHeight = contentArea.outerHeight(),
          contentMaxHeight = contentArea.removeClass(`custom-line-clamp-${contentLineClamp}`).outerHeight();
        contentArea.css('max-height', contentMinHeight)?.attr('data-min-height', contentMinHeight)?.attr('data-max-height', contentMaxHeight)?.addClass(`custom-line-clamp-${contentLineClamp}`);
      });

      // Show more functionality
      $('.image-and-content-with-show-more button').on('click', function () {

        let ctaClicked = $(this),
          contentArea = ctaClicked.parents('.show-more-content').find('.content-area'),
          contentLineClamp = contentArea.attr('data-line-clamp'),
          contentMinHeight = parseInt(contentArea.attr('data-min-height')),
          contentMaxHeight = parseInt(contentArea.attr('data-max-height'));

        if (contentArea.hasClass(`custom-line-clamp-${contentLineClamp}`)) {
          contentArea.removeClass(`custom-line-clamp-${contentLineClamp}`)?.addClass('overflow-hidden')?.animate({ maxHeight: contentMaxHeight }, 300, 'linear');
          ctaClicked.addClass('group active');
          setTimeout(function () {
            ctaClicked.children("span").text("Show Less");
          }, 700);
        } else {
          ctaClicked.removeClass('group active');
          contentArea.animate({ maxHeight: contentMinHeight }, 300, 'linear');
          setTimeout(function () {
            contentArea.addClass(`custom-line-clamp-${contentLineClamp}`).removeClass('overflow-hidden');
            ctaClicked.children("span").text("Show More");
          }, 700);
        }
      });
    }

    //image modal
    $('.member-list').on('click', function () {
      let currentData = $(this),
        imageSrc = currentData.find('img').attr('src'),
        imageAlt = currentData.find('img').attr('alt'),
        heading = currentData.find('h5').text(),
        spanRole = currentData.find('.job-role').text(),
        description = currentData.find('.content-area').html(),
        popUpDiv = $('.team-modal-content');
        popUpDiv.find('figure img').attr('src', imageSrc)?.attr('alt', imageAlt);
        popUpDiv.find('h3').text(heading);
        popUpDiv.find('span').text(spanRole);

        if(description) {
          popUpDiv.find('.content-area').html(description);
        } else {
          popUpDiv.find('.content-area').empty();
        }
  
        $('.popup-image-modal').addClass('team-modal-active');
        $('body').addClass('popup-active');
    });

    $(document).click(function (event) {
      if ($(event.target).closest('.team-modal-close-btn').length || ($(event.target).closest('.popup-image-modal').length && !$(event.target).closest('.image-popup').length)) {
        event.preventDefault();
        $('.popup-image-modal').removeClass('team-modal-active');
        $('body').removeClass('popup-active');
      }
    })

    //popup functionality for journal-block
    $(document).on('click', '.journal-block-card', function () {
      let journalData = $(this);

      researchJournalModalActive(journalData);
    });

    function researchJournalModalActive(journalData) {
      let journalPostId = journalData.attr('data-post-id'),
        journalCategory = journalData.find('.journal-name').text(),
        journalHeading = journalData.find('h5').text(),
        journalImageSrc = journalData.find('.journal-student-image img').attr('src'),
        journalImageAlt = journalData.find('.journal-student-image img').attr('alt'),
        journalStudentName = journalData.find('.journal-student-name').text(),
        journalStudentCountry = journalData.find('.journal-student-country').text(),
        journalStudentUniversity = journalData.find('.journal-student-university').text()
        journalFeatureImgSrc = journalData.find('.journal-featured-img img').attr('src'),
        journalFeatureImgAlt = journalData.find('.journal-featured-img img').attr('alt'),
        journalDescription = journalData.find('.journal-description').children().clone();
      // journalBtn = journalData.find('.journal-btn-container').children().clone(); // commented for future use
      journalPopUpDiv = $('.team-modal-content');
      journalPopUpDiv.find('.journal-popup-img img').attr('src', journalFeatureImgSrc)?.attr('alt', journalFeatureImgAlt);

      if(journalImageSrc && journalStudentName) { //load student image if student name is present
        journalPopUpDiv.find('.journal-speaker-img img').attr('src', journalImageSrc)?.attr('alt', journalImageAlt);
      } else {
        $('.journal-speaker-img').empty();
      }

      journalPopUpDiv.find('h4').text(journalHeading);
      journalPopUpDiv.find('.journal-popup-description').html(journalDescription);
      journalPopUpDiv.find('.journal-popup-heading').text(journalCategory);
      journalPopUpDiv.find('.popup-name').html(journalStudentName);
      journalPopUpDiv.find('.popup-country').html(journalStudentCountry);
      journalPopUpDiv.find('.popup-university').html(journalStudentUniversity);
      // journalPopUpDiv.find('.btn-container').html(journalBtn); // commented for future use
      $('.popup-image-modal').addClass('team-modal-active');
      $('body').addClass('popup-active');
    }

    //journal popup close functionality
    $(document).click(function (event) {
      if ($(event.target).closest('.team-modal-close-btn').length || ($(event.target).closest('.popup-image-modal').length && !$(event.target).closest('.image-popup').length)) {
        $('.popup-image-modal').removeClass('team-modal-active');
        $('body').removeClass('popup-active');
      }
    })

    if ($('.research-journal-section').length) {
      let totalPages = parseInt($('.pagination').attr('data-total-page')),
        postPerPage = parseInt($('.research-journal-section').attr('data-post-per-page')),
        currentPageUrl = window.location.href;
        currentPage = 1;

      const urlObj = new URL(currentPageUrl);

      // Get the value of the 'journal_id' parameter
      const journalId = parseInt(urlObj.searchParams.get("journal_id"));
      // search page landing functionality
      setTimeout(() => {
        if (journalId) {
          $.ajax({
            type: 'GET',
            url: wp_ajax_data.ajax_url,
            data: {
              action: 'get_journal_post_page_number',
              journal_id: journalId,
              posts_per_page: postPerPage
            },
            success: function(response) {
              currentPage = parseInt(response);
  
              generatePagination();
              researchJournalFilter((currentPage - 1) * postPerPage, false, journalId);
  
              const headerHeight = $('header').outerHeight(true),
                childMenuHeight = $('.child-page-menu').length ? $('.child-page-menu').outerHeight(true) : 0,
                wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0,
                offsetScroll = $('.research-journal-section').offset().top - headerHeight - childMenuHeight - wpAdminBar + 110;
              $('html').animate({
                scrollTop: offsetScroll
              }, 300);
            },
            error: function(xhr, status, error) {
              console.warn('Something went wrong!');
            }
          });
        }
      }, 100);

      function researchJournalFilter(offset, scrollToPagination = false, journalId) {
        let categoryTaxonomy = [],
          tagTaxonomy = [],
          journalsTaxonomy = [];

        $('.research-area-filter-list input[type="checkbox"]:checked').each(function () {
          categoryTaxonomy.push($(this).parents('.research-list').attr('data-filter-slug'));
        });
        $('.tag-filter-list input[type="checkbox"]:checked').each(function () {
          tagTaxonomy.push($(this).parents('.research-list').attr('data-filter-slug'));
        });
        $('.journals-filter-list input[type="checkbox"]:checked').each(function () {
          journalsTaxonomy.push($(this).parents('.research-list').attr('data-filter-slug'));
        });

        $.ajax({
          type: 'post',
          url: wp_ajax_data.ajax_url,
          data: {
            action: 'research_journal_filter', // The action name for your backend handler
            category_taxonomy: categoryTaxonomy,
            tag_taxonomy: tagTaxonomy,
            journals_taxonomy: journalsTaxonomy,
            offset: offset,
            post_per_page: postPerPage
          },
          success: function (response) {
            $('.research-resource-container').html('');
            $('.research-resource-container').append(response);
            
            let postFound = $('.research-resource-li'),
            paginationContainer = $('.research-journal-section .pagination');

            if (postFound.length) {
              totalPages = Math.ceil(parseInt($('.research-resource-li').attr('data-total-post')) / postPerPage);
  
              $('.pagination').attr('data-total-page', totalPages);
              generatePagination();
              if (paginationContainer.hasClass('hidden')) {
                paginationContainer.removeClass('hidden');
              }
            } else {
              paginationContainer.addClass('hidden');
            }

            if (scrollToPagination) {
              const headerHeight = $('header').outerHeight(true),
                childMenuHeight = $('.child-page-menu').length ? $('.child-page-menu').outerHeight(true) : 0,
                wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0,
                offsetScroll = $('.research-journal-section').offset().top - headerHeight - childMenuHeight - wpAdminBar + 60;
              $('html').animate({
                scrollTop: offsetScroll
              }, 300);
            }

            // search page landing functionality
            if (journalId) {
              $(`.journal-block-card[data-post-id="${journalId}"]`).click();
            }
          },
          error: function (xhr, status, error) {
            $('.research-resource-container').html('<li class="mb-2 text-center"><h5 class="text-lg mb-0 font-default rounded-xl pl-5 pr-12 py-6">Something went wrong!</h5></li>');
          },
        });
      }

      //added custom functionality for checking and unchecking the checkbox in filter for journal block
      let researchAreaItem = [],
        tagItem = [];
      $('.checkbox-filter-div').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        let $this = $(this),
          clearFilter = $this.parents('.research-main-container').find('.clear-research-filter'),
          capturePlaceholdeText = $this.parents('.research-container').find('.journal-filter').attr('data-placeholder-text');
        if($($this.find('input[type="checkbox"]')[0]).prop('checked') === false) $($this.find('input[type="checkbox"]')[0]).prop('checked', true);
        else $($this.find('input[type="checkbox"]')[0]).prop('checked', false);

        if (capturePlaceholdeText == 'Research Area') {
          updateSelectedText(researchAreaItem, $this, capturePlaceholdeText, clearFilter);
        } else {
          updateSelectedText(tagItem, $this, capturePlaceholdeText, clearFilter);
        }

        researchJournalFilter(0);
      });

      $('.clear-research-filter a').click(function (e) {
        e.preventDefault();
        let clearedFilter = $(this),
        filterCheckbox = clearedFilter.parents('.research-main-container').find('.research-list input[type="checkbox"]'),
        placeholderText = clearedFilter.parents('.research-main-container').find('.journal-filter');

        $('.research-main-container .journal-option-div input[type="checkbox"]').removeAttr('checked');
        $('.research-main-container .research-list a').removeClass('selected');

          placeholderText.each(function() {
            let currentPlaceholder = $(this),
              currentPlaceholderText = currentPlaceholder.attr('data-placeholder-text');

              currentPlaceholder.children().text(currentPlaceholderText);
              currentPlaceholder.children().removeClass('text-color-dark');
          })

        researchJournalFilter(0);
        currentPage = 1;
        clearedFilter.parents('.clear-research-filter').addClass('hidden');
        researchAreaItem = [];
        tagItem = [];
      })

      function updateSelectedText(selectedItems, $this, capturePlaceholdeText, clearFilter) {
        let value = $this.find('label').text(),
          index = selectedItems.indexOf(value),
          placeholderText = $this.parents('.research-container').find('.journal-filter-font');
          currentPage = 1;

        if (index === -1) {
          selectedItems.push(value); // Add to selectedItems array if not already selected
          $this.addClass('selected'); // Optionally add a 'selected' class for visual indication
        } else {
          selectedItems.splice(index, 1); // Remove from selectedItems array if already selected
          $this.removeClass('selected'); // Optionally remove the 'selected' class
        }

        if (selectedItems.length > 0) {
          let firstItem = selectedItems[0], // Get the first selected item
            extraCount = selectedItems.length - 1; // Get the count of additional selected items

          // Check if the length of the first item exceeds 11 characters
          if (firstItem.length > 14) {
            firstItem = firstItem.substring(0, 11) + '...'; // Truncate to 11 characters and add '...'
          }

          if (extraCount > 0) {
            placeholderText.addClass('text-color-dark').text(firstItem + ' + ' + extraCount);
          } else {
            placeholderText.addClass('text-color-dark').text(firstItem);
          }
          if(researchAreaItem.length > 0 || tagItem.length > 0){
            clearFilter.removeClass('hidden');
          }
        } else {
          if(researchAreaItem.length === 0 && tagItem.length === 0) {
            clearFilter.addClass('hidden');
          }

          if(researchAreaItem.length === 0 || tagItem.length === 0){
            placeholderText.removeClass('text-color-dark').text(capturePlaceholdeText);
          }
        }
      }

      $(document).ready(function () {
        generatePagination();

        $(".page-container").on("click", "li[data-page-num]", function () {
          let currentPagination = $(this);
          currentPage = parseInt($(currentPagination).attr("data-page-num"));
          researchJournalFilter((currentPage - 1) * postPerPage, true);
        });

        $(document).on("click","#prev:not(.disabled)",function() {
          if (currentPage > 1) {
            currentPage--;
            researchJournalFilter((currentPage - 1) * postPerPage, true);
          }
        });

        $(document).on("click","#next:not(.disabled)",function() {
          if (currentPage < totalPages) {
            currentPage++;
            researchJournalFilter((currentPage - 1) * postPerPage, true);
          }
        });
      });

      function generatePagination() {
        let pagination = $(".page-container").empty();
        let startPage = Math.max(currentPage - 1, 1);
        let endPage = Math.min(startPage + 2, totalPages);

        pagination.append("<li id='prev' class='page-list faq-prev-btn'>Previous</li>");
        currentPage === 1 ? $("#prev").addClass('disabled') : null;

        if (startPage > 1) {
          pagination.append($("<li class='page-list' data-page-num='1'>").text(1));
          if (startPage > 2) {
            pagination.append($("<li class='page-list dots'>").text("..."));
          }
        }

        for (let i = startPage; i <= endPage; i++) {
          let listItem = $("<li>").text(i);
          listItem.addClass('page-list');
          if (i === currentPage) {
            listItem.addClass("page-active");
          }
          listItem.attr("data-page-num", i);
          pagination.append(listItem);
        }

        if (endPage < totalPages) {
          if (endPage < totalPages - 1) {
            pagination.append($("<li class='page-list dots'>").text("..."));
          }
          pagination.append($("<li class='page-list' data-page-num='" + totalPages + "'>").text(totalPages));
        }

        pagination.append("<li id='next' class='page-list faq-next-btn'>Next</li>");
        currentPage === totalPages ? $("#next").addClass('disabled') : null;
      }
    }

    //journal filter dropdown
    $('.journal-filter').click(function (event) {
      event.preventDefault();
      let currentJournal = $(this),
        currntJournalParent = currentJournal.parent(),
        currentDropdown = currntJournalParent.find('.journal-option-div');
      let isCurrentlyOpen = currentDropdown.is(':visible');

      $('.journal-option-div').slideUp();
      $('.journal-filter').parent().removeClass('filter-toggle-active');
      if (!isCurrentlyOpen) {
        currntJournalParent.addClass('filter-toggle-active');
        currentDropdown.slideDown();
      }
    })

    $(document).click(function (event) {
      if (!$(event.target).closest('.research-container').length || !$(event.target).closest('.filter-toggle-active').length) {
        $('.journal-option-div').slideUp();
        $('.journal-filter').parent().removeClass('filter-toggle-active');
      }
    })

    // filter search function
    $('.research-filter-search').on('keyup', function () {
      let input = $(this),
        searchVal = input.val();
      let filterItems = input.parents('.research-container').find('.research-list');
      if (searchVal != '') {
        filterItems.addClass('hidden');
        input.parents('.research-container').find('.research-list[data-filter-name*="' + searchVal.toLowerCase() + '"]').removeClass('hidden');
      } else {
        filterItems.removeClass('hidden');
      }
    });

    //gallery slider with modal
    $('.popup-image-container img').click(function (e) {
      e.stopPropagation();
    })

    $('.modal-btn-container').click(function (e) {
      e.stopPropagation();
    })

    $('.modal-image').click(function (e) {
      $('.silder-modal-popup').addClass('popup-active')
      $('body').addClass('popup-active');
    });

    $('.modal-close-btn').click(function (e) {
      $('.silder-modal-popup').removeClass('popup-active')
      $('body').removeClass('popup-active');
    })

    //pioneer scholar block year slider
    $('.year-btn').click(function (e) {
      e.preventDefault();
    });

    // to check wheather category blog container is in Viewport or not
    function isInViewport(elementClass) {
      if ($(elementClass).offset()) {
        let elementBottom = $(elementClass).offset().top + $(elementClass).outerHeight();
        let viewportBottom = $(window).scrollTop() + $(window).height();

        return elementBottom < viewportBottom;
      }
    };

    // load more on scroll
    $(window).on("scroll", function () {
      $('.scholar-list').each((index, element) => {
        if (isInViewport('.scholar-lists') && $(element).hasClass('hidden')) {
          $(element).slideDown();
        }
      });
    })

    //prevent default click
    // if ($('a[data-fancybox]').length) {
    //   $('.accreditation-anchor-image').parents('ul').each(function (index, element) {
    //     let currentContainer = $(this);
    //     currentContainer.find('a[data-fancybox]').each(function () {
    //       let currentFancybox = $(this);
    //       currentFancybox.attr('data-fancybox', 'gallery-' + index);
    //     })
    //   });
      
    //   $('.accreditation-anchor-image').click(function () {
    //     let currentClicked = $(this),
    //       elementparent = currentClicked.parents('ul');

    //     elementparent.find('a[data-fancybox]').fancybox({
    //       buttons: [
    //         'slideShow',
    //         'zoom',
    //         'thumbs',
    //         "download",
    //         'close'
    //       ],
    //       touch: {
    //         vertical: false, // Disable vertical drag/swipe gesture
    //       },
    //       loop: false,
    //       protect: true,
    //     });
    //   })
    // }

    //video page 
    //dropdown functionality
    if ($(".topic-container").length) {
      $(document).on("click", ".topic-container-btn", function () {
        if (!$(".topic-container").hasClass('topic-container-active')) {
          $(".topic-container").addClass("topic-container-active");
          $('.video-category-menu').slideDown(500);
          $(".topic-container-btn").addClass('topic-container-btn-active');
        } else {
          $(".topic-container").removeClass("topic-container-active");
          $('.video-category-menu').slideUp(500);
          $(".topic-container-btn").removeClass('topic-container-btn-active')
        }
      });
    }

    //function for showmore
    $('.btn-video-show-more').click(function (e) {
      e.preventDefault();
      let currntBtn = $(this),
        sectionContainer = currntBtn.parents('section'),
        membersList = $(sectionContainer).find('.all-members-list'),
        totalPostCount = $(membersList).data('post-count'),
        postCount = $(membersList).find('li:not(.hidden)').length,
        hiddenPost = $(sectionContainer).find(".video-category-post.hidden"),
        increment = $(membersList).data('increment'),
        listHeight = $(membersList).find('li:not(.hidden)'),
        listLastItem = listHeight[listHeight.length - 1];

      $(hiddenPost).slice(0, increment).slideDown().removeClass('hidden');
      if (totalPostCount <= (postCount + increment)) {
        $(sectionContainer).find('.btn-video-show-more').addClass('hidden');
      }
      $(sectionContainer).find('.btn-video-show-less').removeClass('hidden');
      $('html, body').delay(300).animate({
        scrollTop: ($(listLastItem).offset().top + ($(listLastItem).height() / 2))
      }, 300);
    });

    //function for showless
    $('.btn-video-show-less').click(function (e) {
      e.preventDefault();
      let currntBtn = $(this)
      sectionContainer = currntBtn.parents('section'),
        membersList = $(sectionContainer).find('.all-members-list'),
        postCount = $(membersList).find('li:not(.hidden)').length,
        visiblePost = $(sectionContainer).find('.video-category-post:not(.hidden)'),
        increment = $(membersList).data('increment'),
        postToDispaly = $('.all-members-list').attr('data-post-per-page'),
        currentList = $(membersList).find('li:not(.hidden)');

      if (postCount < (postToDispaly + increment)) {
        let PostToHide = (postCount - postToDispaly);
        $(visiblePost).slice(-PostToHide).addClass('hidden').slideUp();
      } else {
        $(visiblePost).slice(-increment).addClass('hidden').slideUp();
      }
      if ($(membersList).find('li:not(.hidden)').length <= postToDispaly) {
        $(sectionContainer).find('.btn-video-show-less').addClass('hidden');
      }
      $(sectionContainer).find('.btn-video-show-more').removeClass('hidden');

      let updatedListHeight = $(membersList).find('li:not(.hidden)'),
        updatedListLastItem = updatedListHeight[updatedListHeight.length - 1],
        lastLiOffset = $(updatedListLastItem).offset().top,
        headerHeight = $('header').outerHeight(true),
        videoTopicBlock = $('.video-topics-block').length ? $$('.video-topics-block').outerHeight(true) : 0;


      $('html, body').delay(300).animate({
        scrollTop: (lastLiOffset - (headerHeight + videoTopicBlock + 30))
      }, 300);
    });

    if ($('.category-blog-container-listing').length) {
      // function for pagination 
      let totalPages = parseInt($('.pagination').attr('data-total-page')),
      postPerPage = parseInt($('.category-blog-container-listing').attr('data-post-per-page')),
      currentNewsPage = 1;

       // category filter
      //for 3 level sub category
      $(document).on('click', '.child-sub-category .category-list a', function (e) {
        e.preventDefault();
        let childCategory = $(this),
          category_slug = childCategory.parent().attr('data-term-slug'),
          category_name = childCategory.parent().attr('data-term-name');
        offset = 0;
        $('.child-sub-category li').removeClass('active');
        childCategory.parent().addClass('active');
        currentNewsPage = 1;
        filter_post_by_category(category_slug, category_name, offset);
      });

      // to check wheather category blog container is in Viewport or not
      function isInViewport(elementClass) {
        if ($(elementClass).offset()) {
          let elementBottom = $(elementClass).offset().top + $(elementClass).outerHeight();
          let viewportBottom = $(window).scrollTop() + $(window).height();
          return elementBottom < viewportBottom;
        }
      };

      function filter_post_by_category(category_slug, category_name, offset) {
        let postPerPage = parseInt($('.category-blog-container-listing').attr('data-post-per-page'));

        $.ajax({
          type: 'post',
          url: wp_ajax_data.ajax_url,
          data: {
            action: 'pioneer_filter_post_by_category',
            category_slug: category_slug,
            category_name: category_name,
            offset: offset
          },
          datatype: 'json',
          success: function (response) {
            $('.bolgs-by-category .category-blog-container .category-blog-container-listing').remove();
            $('.bolgs-by-category .category-blog-container').prepend(response);

            totalPages = Math.ceil(parseInt($('.category-blog-container-listing').attr('data-total-post')) / postPerPage);

            $('.pagination').attr('data-total-page', totalPages);
            generateNewsPagination();
          },
          error: function () {
            $('.bolgs-by-category .category-blog-container .category-blog-container-listing').append('<div class="text-center text-pa-red text-lg py-5"><span>Something went wrong!</span></div>');
          },
        });
      }

      function news_filter_post(offset, category_slug, category_name, animation = true) {
        $body_has_class = $('body').hasClass('category');

        if (animation) {
          $('html, body').animate({ scrollTop: 0 });
        }

        $.ajax({
          type: 'post',
          url: wp_ajax_data.ajax_url,
          data: {
            action: 'pioneer_filter_post_by_category',
            category_slug: category_slug,
            category_name: category_name,
            offset: offset
          },
          datatype: 'json',
          success: function (response) {
            setTimeout(() => {
              $('.category-blog-container-listing').html('');
              $('.category-blog-container-listing').append(response);
  
              totalPages = Math.ceil(parseInt($('.category-blog-container-listing').attr('data-total-post')) / postPerPage);
  
              $('.pagination').attr('data-total-page', totalPages);
              generateNewsPagination();
            }, 300);
          },
          error: function (xhr, status, error) {
            $('.category-blog-container-listing').html('<li class="mb-2 text-center"><h5 class="text-lg mb-0 font-default rounded-xl pl-5 pr-12 py-6">Something went wrong!</h5></li>');
          },
        });
      }

      function generateNewsPagination() {
        let pagination = $(".category-blog-container .pagination .page-container").empty();
        
        let startPage, endPage;

        pagination.append("<li id='prev' class='page-list faq-prev-btn'>Previous</li>");
        currentNewsPage === 1 ? $("#prev").addClass('disabled') : null;

        // If total pages are 5 or fewer, display all pages without "..."
        if (totalPages <= 5) {
          startPage = 1;
          endPage = totalPages;
        } else {
          // For more than 5 pages, set start and end pages for a sliding window effect
          startPage = Math.max(currentNewsPage - 1, 1);
          endPage = Math.min(startPage + 2, totalPages);
        }
      
        if (startPage > 1) {
          pagination.append($("<li class='page-list' data-page-num='1'>").text(1));
          if (startPage > 2) {
            pagination.append($("<li class='page-list dots'>").text("..."));
          }
        }
      
        for (let i = startPage; i <= endPage; i++) {
          let listItem = $("<li>").text(i);
          listItem.addClass('page-list');
          if (i === currentNewsPage) {
            listItem.addClass("page-active");
          }
          listItem.attr("data-page-num", i);
          pagination.append(listItem);
        }
      
        if (endPage < totalPages) {
          if (endPage < totalPages - 1) {
            pagination.append($("<li class='page-list dots'>").text("..."));
          }
          pagination.append($("<li class='page-list' data-page-num='" + totalPages + "'>").text(totalPages));
        }

        pagination.append("<li id='next' class='page-list faq-next-btn'>Next</li>");
        currentNewsPage === totalPages ? $("#next").addClass('disabled') : null;
      }    
    
      $(document).ready(function () {
        generateNewsPagination();

        $(".page-container").on("click", "li[data-page-num]", function () {
          let currentPagination = $(this),
          category_slug = $('.category-blog-container-listing').attr('data-category-slug'),
          category_name =  $('.category-blog-container-listing').attr('data-category-name');
          currentNewsPage = parseInt($(currentPagination).attr("data-page-num"));
          
          news_filter_post((currentNewsPage - 1) * postPerPage, category_slug, category_name);
        });

        $(document).on("click","#prev:not(.disabled)",function() {
          if (currentNewsPage > 1) {
            currentNewsPage--;
            let currentPagination = $(this),
            category_slug = $('.category-blog-container-listing').attr('data-category-slug'),
            category_name =  $('.category-blog-container-listing').attr('data-category-name');
            
            news_filter_post((currentNewsPage - 1) * postPerPage, category_slug, category_name);
          }
        });

        $(document).on("click","#next:not(.disabled)",function() {
          if (currentNewsPage < totalPages) {
            currentNewsPage++;
            let currentPagination = $(this),
            category_slug = $('.category-blog-container-listing').attr('data-category-slug'),
            category_name =  $('.category-blog-container-listing').attr('data-category-name');
            
            news_filter_post((currentNewsPage - 1) * postPerPage, category_slug, category_name);
          }
        });
      });
    }
    // category end

    if ($('.child-page-menu').length) {
      if ($('.child-page-dropdown').hasClass('overflow-hidden')) {
        $('.child-page-dropdown').removeClass('overflow-hidden');
      }
      function calcWidth() {
        let navwidth = 0;
        let morewidth = $('.child-menu-container .more').outerWidth(true);
        $('.child-menu-container > li:not(.more)').each(function () {
          navwidth += $(this).outerWidth(true);
        });
        let availablespace = $('.child-page-dropdown').outerWidth(true) - morewidth;

        if ((navwidth > availablespace) && (window.innerWidth > 767)) {
          let lastItem = $('.child-menu-container > li:not(.more)').last();
          lastItem.attr('data-width', lastItem.outerWidth(true));
          lastItem.prependTo($('.child-menu-container .more ul'));
          $('.child-menu-container').attr('style', '');
          if ($('.dropdown-active-page, .sub-child-page').hasClass('child-dropdown-active')) {
            $('.dropdown-active-page, .sub-child-page').removeClass('child-dropdown-active')
          }
          calcWidth();
        } else if ((navwidth < availablespace) && (window.innerWidth > 767)) {
          let firstMoreElement = $('.child-menu-container .more li').first();
          $('.child-menu-container').attr('style', '');
          if (navwidth + firstMoreElement.data('width') < availablespace) {
            firstMoreElement.insertBefore($('.child-menu-container .more'));
            if ($('.dropdown-active-page, .sub-child-page').hasClass('child-dropdown-active')) {
              $('.dropdown-active-page, .sub-child-page').removeClass('child-dropdown-active')
            }
          }
        } else if (window.innerWidth <= 767) {
          let moreMenuList = $('.child-menu-container .more-sub-menu > li');
          moreMenuList.insertBefore($('.child-menu-container .more'));
        }

        $('.more li').length ? $('.more').css('display', 'inline-block') : $('.more').css('display', 'none');
      }
      calcWidth();
      $(window).on('resize', function () {
        calcWidth();
      });

      $('.child-menu-container .more > a').click(function (e) {
        e.preventDefault();
        let currentClicked = $(this),
          categoryDropdown = $(currentClicked).parents('.more').find('.more-sub-menu');
        currentClicked.parent().toggleClass('more-menu-active');
        categoryDropdown.slideToggle();
      });

      if ($('.child-page-menu .more-sub-menu').length) {
        $(document).click(function (event) {
          if (!$(event.target).closest('.child-page-menu .more').length && !$(event.target).closest('.child-page-menu .more-sub-menu').length) {
            $('.child-page-menu .more-sub-menu').slideUp();
            $('.child-page-menu .more').removeClass('more-menu-active');
          }
        });
      }

      $('.dropdown-active-page a').click(function (e) {
        e.preventDefault();
        if (window.innerWidth < 767) {
          let currentClicked = $(this),
            categoryDropdown = $(currentClicked).parents('.wrapper').find('.child-menu-container');
          categoryDropdown.slideToggle();
          currentClicked.parent().toggleClass('child-dropdown-active');
        }
      });

      $('.child-menu-container .sub-child-page').click(function () {
        if (window.innerWidth < 767) {
          let childDropdown = $(this);

          if (!childDropdown.hasClass('child-dropdown-active')) {
            $('.child-menu-container .child-sub-menu').slideUp();
            $('.child-menu-container .sub-child-page').removeClass('child-dropdown-active');
          }

          childDropdown.find('.child-sub-menu').slideToggle();
          childDropdown.toggleClass('child-dropdown-active');
        }
      });

      $('.sub-child-page .has-tertiary-menu').click(function (e) {
        if (window.innerWidth < 767) {
          e.stopPropagation();
          let childDropdown = $(this);

          if (!childDropdown.hasClass('child-dropdown-active')) {
            $('.has-tertiary-menu ul').slideUp();
            $('.sub-child-page .has-tertiary-menu').removeClass('child-dropdown-active');
          }

          childDropdown.find('.child-mobile-static-menu').slideToggle();
          childDropdown.toggleClass('child-dropdown-active');
        }
      });
    }

    $(document).ready(function () {
      let recordingsCardLength = $('.recordings-card').length,
        incrementNumber = $('.speaker-watch-list').attr('data-card-increment'),
        visibleRecordingCards = $('.speaker-watch-list > li.hidden').length;

      $('.load-more-speakers').click(function (e) {
        e.preventDefault();
        let hiddenRecordingCards = $('.speaker-watch-list > li.hidden');
        if (recordingsCardLength > incrementNumber) {
          $(hiddenRecordingCards).slice(0, incrementNumber).slideDown().removeClass('hidden');
        }
        visibleRecordingCards = $('.speaker-watch-list > li.hidden').length;
        if (visibleRecordingCards == 0) {
          $('.load-more-speakers').addClass('hidden');
        }
      });
    });

    //tabs functionality for speaker video single page
    $('.summit-tabs').click(function (e) {
      e.preventDefault();
      $('.summit-tabs').removeClass('active-summit-tab');
      $(this).addClass('active-summit-tab');
      let summitTabId = $(this).attr('id');
      $('.summit-video-content li').removeClass('active-desc-tab');
      $('.summit-video-content li#' + summitTabId).addClass('active-desc-tab');
    });

    if ($('.pioneer-excel-section .grade-chart').length) {
      // Function to set legend position based on window width
      let legendPosition = "left";
      function setLegendPosition() {
        let width = $(window).width();
        legendPosition = (width < 767) ? 'bottom' : 'left';
      }

      setLegendPosition(); // Initial set of legend position
      $('.pioneer-excel-section ul li').each(function () {
        let grade = $(this),
          gradeValue = grade.attr('data-grade-value'),
          gradeTitle = grade.attr('data-grade-title'),
          ctx = $(grade).find('.grade-chart');

        let chart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: JSON.parse(gradeTitle),
            datasets: [{
              data: JSON.parse(gradeValue),
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 4 / 2,
            plugins: {
              legend: {
                display: true,
                position: legendPosition,
                align: 'middle',
                labels: {
                  font: {
                    size: 14
                  }
                }
              }
            },
          }
        });

        // Update chart on window resize
        $(window).resize(function () {
          setLegendPosition();
          chart.options.plugins.legend.position = legendPosition;
          chart.update();
        });
      });
    }

    //function for sub-menu active state
    const menuPrimaryNavigation = $('#menu-primary-navigation');
    if (menuPrimaryNavigation.length) {
      const currentPageUrl = window.location.href;
      const submenuItems = $('.sub-menu li a');

      submenuItems.each(function () {
        const currentElement = $(this),
          menuText = currentElement.text().toLowerCase(),
          menuUrl = currentElement.attr('href');

        if ((currentPageUrl === menuUrl && menuText === 'overview') || (currentPageUrl.includes(menuUrl) && menuText !== 'overview')) {
          currentElement.addClass("active-anchor");
          currentElement.parents('.menu-item-has-children').addClass('underline-active');
        } else {
          currentElement.removeClass("text-pa-red active-anchor");
        }
      });

      menuPrimaryNavigation.find('> li > a').each(function () {
        const mainMenu = $(this),
          mainMenuUrl = mainMenu.attr('href');

        if (currentPageUrl.includes(mainMenuUrl)) {
          mainMenu.parent().addClass('underline-active');
        }
      });
    }

    // GPSI elegibility form
    if ($('.gpsi-form-modal').length) {
      $('.gpsi-modal-cta').on('click', function(e) {
        e.preventDefault();
        $('.gpsi-form-modal').addClass('team-modal-active');
        $('body').addClass('popup-active');
      })

      $(".gpsi-form-modal .gpsi-radio-btn-container label").click(function(e) {
        let regionInput = $(this),
          regionLabel = regionInput.children('span').text(),
          selectCountry = regionInput.parents('.gpsi-form-modal').find('.selected-country select'),
          previousForm = $(".previous-form-active input");

        if (regionLabel == 'Other' && previousForm.is(':checked')) {
          if (selectCountry.length) {
            selectCountry.val(regionLabel); // Set dropdown to selected country
            selectCountry.trigger('change')
          }

          previousForm.prop('checked', function(i, value) {
            return !value; // Toggle the checked property
          }).triggerHandler('click'); // Trigger the click event manually
        }
      });

      $(".gpsi-form-modal .previous-form").click(function(e) {
        e.preventDefault();
        $(".gpsi-radio-btn-container label").each(function () {
          let regionLabel = $(this),
          regionInputLabel = regionLabel.children('span').text();

          if (regionInputLabel == 'Other') {
            regionLabel.children('input').prop('checked', function(i, value) {
              return !value; // Toggle the checked property
            }).triggerHandler('click'); // Trigger the click event manually
          }
        })

        $(".previous-form-active input").prop('checked', function(i, value) {
          return !value; // Toggle the checked property
        }).triggerHandler('click'); // Trigger the click event manually
      });

      //form modal close
      $(document).click(function (event) {
        if ($(event.target).closest('.team-modal-close-btn').length || ($(event.target).closest('.gpsi-form-modal').length && !$(event.target).closest('.image-popup').length)) {
          $('.gpsi-form-modal').removeClass('team-modal-active');
          $('body').removeClass('popup-active');
        }
      })
    }

    if ($('.header-search-cta').length) {
      $('.header-search-cta').click(function (e) {
        e.preventDefault();
        let searchCtaClicked = $(this),
          searchInput = (window.innerWidth >= 1024) ? $('.search-form-desktop').find('input') : $('.search-form-mobile').find('input'),
          searchButton = (window.innerWidth >= 1024) ? $('.search-form-desktop').find('button') : $('.search-form-mobile').find('button'),
          searchBoxContainer = (window.innerWidth >= 1024) ? $('.search-form-desktop') : $('.search-form-mobile');

          searchBoxContainer.fadeToggle();
          searchInput.focus();

          // Check input on keyup to toggle submit button
          searchInput.on('keyup', function() {
            if ($(this).val().trim() !== "") {
              searchButton.parents('.search-input-container').removeClass('search-error');
            } else {
              searchButton.parents('.search-input-container').addClass('search-error');
            }
          });
      });

      $('.search-form').on('submit', function (e) {
        let currentForm = $(this),
        searchInput = (window.innerWidth >= 1024) ? $('.search-form-desktop').find('input') : $('.search-form-mobile').find('input');
        if (searchInput.val().trim() == '') {
          e.preventDefault();
          currentForm.find('.search-input-container').addClass('search-error');
        }
      })

      $(document).click(function (event) {
        if (!$(event.target).closest('.header-search-container').length && !$(event.target).closest('.search-form-container').length) {
          $('.search-form-container').fadeOut();
        }
      });
    }

    if ($('body.search').length) {
      let totalPages = parseInt($('.pagination').attr('data-total-page')),
          postPerPage = parseInt($('.search-list-container').attr('data-post-per-page')),
          searchPageValue = $('#search-page-input').val(),
          currentPage = 1;

      if (searchPageValue != '') {
        $('.search-cta-container .search-page-empty-btn').removeClass('hidden');
      }

      function updateUrlWithSearchQuery() {
        let searchQuery = $('#search-page-input').val().trim(), // Get the input value
          encodedQuery = encodeURIComponent(searchQuery).replace(/%20/g, '+'),
          origin = window.location.origin, // e.g., "https://example.com"
          path = window.location.pathname, // e.g., "/search/"
          newUrl = `${origin}${path}?s=${encodedQuery}`;

        window.history.pushState({ path: newUrl }, '', newUrl);
      }

      $('#search-page-input').on('input', function () {
        let searchData = $(this), // Get the input value
        searchInputError = $('.search-page-section .search-page-container').find('.search-error-message');

        if (searchData.val().trim() != '') {
          $('.search-cta-container .search-page-empty-btn').removeClass('hidden');
          if (searchInputError.length != 0) {
            searchInputError.remove();
          }
        } else {
          $('.search-cta-container .search-page-empty-btn').addClass('hidden');
          if (searchInputError.length == 0) {
            $('.search-page-section .search-page-container').append('<span class="search-error-message">This field is required</span>');
          }
        }
      });

      $('#search-page-input').on('keydown', function (e) {
        let searchData = $(this).val().trim(), // Get the input value
        searchInputError = $('.search-page-section .search-page-container').find('.search-error-message');

        if (e.which === 13) { // 13 is the keycode for Enter
          e.preventDefault(); // Prevent the default form submission (if inside a form)
          currentPage = 1;

          if (searchData != '') {
            if (searchInputError.length != 0) {
              searchInputError.remove();
            }
            filter_search_page_post(0, 'all', searchData);
            search_page_tab_filter_update(searchData);
            updateUrlWithSearchQuery();
          } else {
            if (searchInputError.length == 0) {
              $('.search-page-section .search-page-container').append('<span class="search-error-message">This field is required</span>');
            }
          }
        }
      });

      $('.search-banner-cta').click(function (e) {
        e.preventDefault();
        let searchData = $('#search-page-input').val().trim(),
        searchInputError = $('.search-page-section .search-page-container').find('.search-error-message');
        currentPage = 1;

        if (searchData != '') {
          if (searchInputError.length != 0) {
            searchInputError.remove();
          }
          filter_search_page_post(0, 'all', searchData);
          search_page_tab_filter_update(searchData);
          updateUrlWithSearchQuery();
        } else {
          if (searchInputError.length == 0) {
            $('.search-page-section .search-page-container').append('<span class="search-error-message">This field is required</span>');
          }
        }
      })

      $('.search-page-empty-btn').click(function () {
        $('#search-page-input').val(null).focus();;
        $('.search-page-empty-btn').addClass('hidden');
      })

      $(document).on('click', '.global-search-list a:not([data-page-id="more"])', function(e) {
        e.preventDefault();
        let tabClicked = $(this),
          searchData = $('.search-page-container input').val().trim() != '' ? $('.search-page-container input').val().trim() : $('.search-section').attr('data-searched-term'),
          postNotIn = '',
          selectPost = tabClicked.attr('data-page-id') != 'all' ? JSON.parse(tabClicked.attr('data-page-id')) : tabClicked.attr('data-page-id'); // Replace with your total number of pages
          currentPage = 1;

          if (tabClicked.parent().hasClass('search-other-page')) {
            postNotIn = selectPost,
            selectPost = '';
          }

          $('.global-search-list').removeClass('active');
          tabClicked.parent().addClass('active');

          filter_search_page_post(0, selectPost, searchData, true, postNotIn);
      });

      function search_page_tab_filter_update(searchData) {
        $.ajax({
          type: 'post',
          url: wp_ajax_data.ajax_url,
          data: {
            action: 'search_page_tab_filter_update',
            search_val: searchData,
          },
          datatype: 'json',
          beforeSend: function() {
            $('.global-search-tab li').addClass('skeleton');
          },
          success: function (response) {
            $('.search-tab-container .global-search-tab').html('');
            $('.search-tab-container .global-search-tab').append(response);
            adjustTabs();
            $('.skeleton').removeClass('skeleton');
          },
          error: function (xhr, status, error) {
            $('.search-tab-container .global-search-tab').html('<li class="mb-2 text-center"><h5 class="text-lg mb-0 font-default rounded-xl pl-5 pr-12 py-6">Something went wrong!</h5></li>');
          },
        });
      }
      
      function filter_search_page_post(offset, selectPost, searchData, animation = true, postNotIn) {
        $.ajax({
          type: 'post',
          url: wp_ajax_data.ajax_url,
          data: {
            action: 'search_page_tab_filter',
            offset: offset,
            post_per_page: postPerPage,
            select_post: selectPost,
            search_val: searchData,
            post_not_in: postNotIn,
          },
          datatype: 'json',
          beforeSend: function() {
            $('.search-list-container h4').addClass('skeleton');
            $('.search-list-container p').addClass('skeleton');
          },
          success: function (response) {
            let totalCount = 0,
            paginationContainer = $('.pagination');
            $('.search-list-container').html('');

            if (response) {
              $('.search-list-container').append(response);
              totalCount = parseInt($('.search-list-container li:first').attr('data-total-post'));
              $('.search-section .count-text').text(totalCount);
            } else {
              $('.search-list-container').append('<li class="blog-card mt-6 pb-6 border-b border-pa-grey/20 last:border-b-0 last:pb-0" data-total-post="<?php echo $total_posts; ?>"><p>Oops! We couldn\'t find any matches for your search. Try adjusting your keywords.</p></li>');
              $('.search-section .count-text').text(0);
            }
            $('.search-section').attr('data-searched-term', searchData);
            $('.skeleton').removeClass('skeleton');

            if (totalCount) {
              totalPages = Math.ceil(totalCount / postPerPage);
  
              $('.pagination').attr('data-total-page', totalPages);
              generatePagination();
              if (paginationContainer.hasClass('hidden')) {
                paginationContainer.removeClass('hidden');
              }
            } else {
              paginationContainer.addClass('hidden');
            }
            
            let adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
              contentTopHeight = $(".search-section").offset().top - ($('header').outerHeight() + adminBarHeight + 20);
            if (animation) {
              $('html, body').delay(300).animate({
                scrollTop: contentTopHeight
              });
            }
          },
          error: function (xhr, status, error) {
            $('.search-list-container').html('<li class="mb-2 text-center"><h5 class="text-lg mb-0 font-default rounded-xl pl-5 pr-12 py-6">Something went wrong!</h5></li>');
          },
        });
      }

      generatePagination();

      $(".page-container").on("click", "li[data-page-num]", function () {
        let currentPagination = $(this),
        activeTab = $('.global-search-tab li.active a'),
        searchData = $('.search-page-container input').val().trim() != '' ? $('.search-page-container input').val().trim() : $('.search-section').attr('data-searched-term'),
        selectPost = activeTab.attr('data-page-id') != 'all' ? JSON.parse(activeTab.attr('data-page-id')) : activeTab.attr('data-page-id'); // Replace with your total number of pages
        currentPage = parseInt($(currentPagination).attr("data-page-num"));
        filter_search_page_post((currentPage - 1) * postPerPage, selectPost, searchData);
      });

      $(document).on("click","#prev:not(.disabled)",function() {
        let activeTab = $('.global-search-tab li.active a'),
        searchData = $('.search-page-container input').val().trim() != '' ? $('.search-page-container input').val().trim() : $('.search-section').attr('data-searched-term'),
        selectPost = activeTab.attr('data-page-id') != 'all' ? JSON.parse(activeTab.attr('data-page-id')) : activeTab.attr('data-page-id'); // Replace with your total number of pages

        if (currentPage > 1) {
          currentPage--;
          filter_search_page_post((currentPage - 1) * postPerPage, selectPost, searchData);
        }
      });

      $(document).on("click","#next:not(.disabled)",function() {
        let activeTab = $('.global-search-tab li.active a'),
        searchData = $('.search-page-container input').val().trim() != '' ? $('.search-page-container input').val().trim() : $('.search-section').attr('data-searched-term'),
        selectPost = activeTab.attr('data-page-id') != 'all' ? JSON.parse(activeTab.attr('data-page-id')) : activeTab.attr('data-page-id'); // Replace with your total number of pages
        
        if (currentPage < totalPages) {
          currentPage++;
          filter_search_page_post((currentPage - 1) * postPerPage, selectPost, searchData);
        }
      });

      function generatePagination() {
        if (!$(".page-container").length) {
          let pageContainer = $('<div class="pagination flex gap-2 justify-center" data-total-page="0"><ul class="page-container flex flex-wrap justify-center gap-2"></ul></div>');
          $('.search-section .single-wrapper').append(pageContainer);
        } else {
          let pagination = $(".page-container").empty();
          let startPage = Math.max(currentPage - 1, 1);
          let endPage = Math.min(startPage + 2, totalPages);
          if (!$('.pagination').hasClass('mt-20')) {
            $('.pagination').addClass('mt-20');
          }
  
          pagination.append("<li id='prev' class='page-list faq-prev-btn'>Previous</li>");
          currentPage === 1 ? $("#prev").addClass('disabled') : null;
  
          if (startPage > 1) {
            pagination.append($("<li class='page-list' data-page-num='1'>").text(1));
            if (startPage > 2) {
              pagination.append($("<li class='page-list dots'>").text("..."));
            }
          }
  
          for (let i = startPage; i <= endPage; i++) {
            let listItem = $("<li>").text(i);
            listItem.addClass('page-list');
            if (i === currentPage) {
              listItem.addClass("page-active");
            }
            listItem.attr("data-page-num", i);
            pagination.append(listItem);
          }
  
          if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
              pagination.append($("<li class='page-list dots'>").text("..."));
            }
            pagination.append($("<li class='page-list' data-page-num='" + totalPages + "'>").text(totalPages));
          }
  
          pagination.append("<li id='next' class='page-list faq-next-btn'>Next</li>");
          currentPage === totalPages ? $("#next").addClass('disabled') : null;
        }
      }


      function adjustTabs() {
        const container = $(".search-tab-container");
        const tabs = $(".global-search-tab .global-search-list");
        const moreTab = $(".more-page-tab a");
        const containerWidth = container.width();
        const moreTabWidth = moreTab.parent().outerWidth(true); // Include margins

        // Reset the visibility of all tabs
        tabs.removeClass("hidden");
        $(".global-search-tab").removeClass('flex-nowrap').addClass('flex-wrap');
        moreTab.parent().addClass("hidden"); // Hide the "More" tab initially

        let availableWidth = containerWidth - moreTabWidth; // Space for tabs
        let totalTabWidth = 0;
        let visibleTabs = 0;

        // Calculate the width of each tab and determine how many can fit
        tabs.each(function () {
          totalTabWidth += $(this).outerWidth(true); // Include margins

          // If there's enough space or it's one of the first three tabs, show it
          if (totalTabWidth <= availableWidth || visibleTabs < 3) {
            visibleTabs++;
          } else {
            $(this).addClass("hidden"); // Hide overflowing tabs
          }
        });

        // Show or hide the "More" tab based on how many tabs are visible
        if (visibleTabs < tabs.length) {
          moreTab.parent().removeClass("hidden"); // Show "More" if there are hidden tabs
        }
      }

      function toggleHiddenTabs(e) {
        e.preventDefault();
        $(this).parent().hide();
        $(".global-search-tab .hidden").toggle(); // Toggle visibility of hidden tabs
      }

      // Initial adjustment
      adjustTabs();

      // On "More" click, toggle visibility of hidden tabs
      $(document).on("click", ".more-page-tab a", toggleHiddenTabs);

      // Handle window resize
      $(window).on("resize", adjustTabs);
    }

    if ($('.skeleton').length) {
      $('.skeleton').removeClass('skeleton');
    }

    if ($('#pdf-report-download').length) {
      $("#pdf-report-download").click(function(e) {
        e.preventDefault();
        const pdfUrl = $(this).attr('href'); // Replace with your PDF URL

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = pdfUrl.split('/').pop(); // Use file name from URL
        
        // Append link to the body
        document.body.appendChild(link);
        
        // Programmatically click the link to trigger the download
        link.click();
        
        // Remove the link from the document
        document.body.removeChild(link);
      });
    }

    if ($('.btn').attr('href') == '#scroll-to-next-section') {
      let headerHeight = $('header').outerHeight(true),
      wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0;
      $('.btn').click(function(e) {
        // Check if the URL hash is `#scroll-to-next-section`
        if ($(this).attr('href') == '#scroll-to-next-section') {
          e.preventDefault();
          // Find the parent section of the clicked CTA
          let parentSection = $(this).closest('section').next();

          $('html, body').animate({
            scrollTop: parentSection.offset().top - headerHeight - wpAdminBar
          });
        }
      });
    }

    // User interaction code
    let userInteracted = false;
    ['click', 'scroll', 'mousemove', 'mousewheel', 'touchstart'].forEach(function(e) {
      document.addEventListener(e, firstInteraction, {
        once: true
      });
    });

    function firstInteraction() {
      if (!userInteracted) {
        userInteracted = true;

        if ($('.notification-bar.active').length) {
          // Check if the notification bar should be hidden
          if (sessionStorage.getItem('notificationHidden')) {
            $('.notification-bar').hide();
            $("main").css('margin-top', 0);
          } else {
            $('.notification-bar').slideDown();
            setTimeout(() => {
              $("main").animate({ marginTop: $(".notification-bar").outerHeight(true) }, 300);
            }, 300);
          }

          $('.notification-bar .close-cta').click(function (e) {
            e.preventDefault();
            $("main").animate({ marginTop: 0 }, 300);
            $('.notification-bar').slideUp(300);
            $('.notification-bar').removeClass('active');
            sessionStorage.setItem('notificationHidden', 'true');
          });
        }
      }
    }

    // Slate form modal
    if ($('.slate-form-modal').length) {
      $('.slate-modal-cta').on('click', function(e) {
        e.preventDefault();
        $('.slate-form-modal').addClass('team-modal-active');
        $('body').addClass('popup-active');
      })

      //form modal close
      $(document).click(function (event) {
        if ($(event.target).closest('.team-modal-close-btn').length || ($(event.target).closest('.slate-form-modal').length && !$(event.target).closest('.image-popup').length)) {
          $('.slate-form-modal').removeClass('team-modal-active');
          $('body').removeClass('popup-active');
        }
      })
    }

    // College acceptance bar height
    if ($('.college-acceptances-short-list').length) {
      // Find all elements with data-university-percentage and data-average-percentage
      $('.college-acceptances-short-list .tab-pane').each(function () {
        let maxPercentage = 0,
          collegeTabContainer = $(this);
        
        collegeTabContainer.find('.bottom-border').each(function () {
          let collegePercentage = $(this);
          const universityPercentage = parseFloat(collegePercentage.data('university-percentage')) || 0;
          const averagePercentage = parseFloat(collegePercentage.data('average-percentage')) || 0;

          maxPercentage = Math.max(maxPercentage, universityPercentage, averagePercentage);
        });

        // Adjust the height of the percentage-bar elements
        collegeTabContainer.find('.bottom-border').each(function () {
          let collegePercentage = $(this);
          const percentage = parseFloat(collegePercentage.data('university-percentage')) || parseFloat(collegePercentage.data('average-percentage')) || 0;
          let heightPercentage = window.innerWidth < 1024 ? (percentage / maxPercentage) * 100 : (percentage / maxPercentage) * 56;
          collegePercentage.find('.percentage-bar').css({ height: `${heightPercentage}%` });

          $(window).on("resize", function () {
            let heightPercentage = window.innerWidth < 1024 ? (percentage / maxPercentage) * 100 : (percentage / maxPercentage) * 56;
            collegePercentage.find('.percentage-bar').css({ height: `${heightPercentage}%` });
          });
        });
      });
    }

    // When a label is clicked
    if ($('.gpsi-form').length) {
      $('.gpsi-form label').on('click', function () {
        // Get the data attributes from the clicked label
        const labelClicked = $(this);
        const ctaTitle = labelClicked.data('cta-title');
        const ctaUrl = labelClicked.data('cta-url');
        const ctaTarget = labelClicked.data('cta-target');

        // Update the anchor tag inside .sticky-continue-button
        const continueButton = $('.gpsi-form-modal .sticky-continue-button a');
        continueButton.attr('href', ctaUrl);
        continueButton.attr('title', ctaTitle);
        continueButton.attr('target', ctaTarget);
        continueButton.text(ctaTitle);

        // Show the .sticky-continue-button if hidden
        if ($('.gpsi-form-modal .sticky-continue-button').hasClass('hidden')) {
          $('.gpsi-form-modal .sticky-continue-button').removeClass('hidden');
        }
      });
    }

    // FAQ Accordion
    if ($('.faq-accordion-section').length) {
      $('.faq-accordion-question').on('click', function () {
        let question = $(this),
        section = question.closest('.faq-accordion-section');

        if (!question.hasClass('active')) {
          section.find('.faq-accordion-question').removeClass('active');
          section.find('.faq-accordion-answer').slideUp();
          question.addClass('active');
          question.next('.faq-accordion-answer').slideToggle();
        } else {
          question.removeClass('active');
          question.next('.faq-accordion-answer').slideUp();
        }
      });
    }
  });

  $(window).on("load resize", function () {
    //function to add padding dynamically to cards list
    if ($('.sticky-slider-container-wrapper').length) {
      let containerHeight = $('.sticky-content').innerHeight() / 2,
        stickyContainer = $('.sticky-number-container'),
        mainContainer = $('.sticky-slider-container-wrapper'),
        totalHeight = "",
        numberListFirstChild = $('.sticky-number-container li:first-child').outerHeight() / 2,
        numberListLastChild = $('.sticky-number-container li:last-child').outerHeight() / 2;

      $(stickyContainer).css('padding-top', containerHeight - numberListFirstChild);
      $(stickyContainer).css('padding-bottom', containerHeight - numberListLastChild);
      if (window.innerWidth >= 1024) {
        totalHeight = $('.sticky-number-container').outerHeight();
        $(mainContainer).css({
          "max-height": totalHeight,
          "height": totalHeight,
          "min-height": totalHeight
        });
      }
    }

    //to close dropdown on click 
    $(document).on("click", ".video-menu", function (e) {
      if (window.innerWidth < 768) {
        setTimeout(function () {
          $(".topic-container").removeClass("topic-container-active");
          $('.video-category-menu').slideUp(500);
          $(".topic-container-btn").removeClass('topic-container-btn-active')
        }, 1000);
      }
    })

    //to display video-category-menu of video block removeStyle('display');
    if (window.innerWidth >= 768) {
      $('.video-category-menu').show();
    } else {
      $('.video-category-menu').hide();
    }


    if ($('.child-page-menu').length) {
      function handleScroll() {
        const scrollY = $(window).scrollTop();
        const $header = $('header'),
        wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0;
        const $filterContainer = $('.child-page-menu');
        const filterOffset = $('.banner-block').length ? $('.secondary-menu-container').offset().top + 30 : $('.secondary-menu-container').offset().top;
        const headerHeight = $header.outerHeight(true) + wpAdminBar;
        const paddingTop = $('.static-secondary-menu').length ? 0 : 28;

        if (scrollY > filterOffset - headerHeight && scrollY > 0) {
          $filterContainer.addClass('child-page-menu-fixed').css({
            'padding-top': paddingTop,
            'top': headerHeight - paddingTop,
            'transition': 'none',
            'z-index': 45
          });

          $('.secondary-menu-container').height($filterContainer.outerHeight());
          // Force a reflow to apply the 'transition: none' immediately
          $filterContainer[0].offsetHeight;
          // Re-enable the transition after a short delay
          setTimeout(() => {
            $('.secondary-menu-container').height($filterContainer.outerHeight());
            $filterContainer.css('transition', '');
          }, 50);
        } else {
          $filterContainer.removeClass('child-page-menu-fixed').attr('style', '');

          $('.secondary-menu-container').height('auto');
        }
      }

      // Event listeners
      $(window).on('scroll', handleScroll);
    }
  });

  if ($('.grand-child-container').length) {
    let menuTop = $('.grand-child-container').offset().top,
      grandChildMenu = $('.grand-child-container .child-sub-category'),
      grandChildMenuTop = grandChildMenu.length ? grandChildMenu.offset().top : 0,
      wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0;
    $(window).on('scroll', function () {
      let headerHeight = $('header').outerHeight(true) + wpAdminBar - 30,
        menuHeight = $('.child-page-menu').length ? $('.child-page-menu').outerHeight(true) : 0,
        grandChildMenuHeight = grandChildMenu.length ? grandChildMenu.outerHeight(true) : 0,
        grandChildMenuOffset = grandChildMenuTop - headerHeight - menuHeight,
        menuOffset = menuTop - headerHeight - menuHeight;
      if (window.scrollY >= menuOffset) {
        $('.grand-child-container').css('top', menuHeight + headerHeight);
      } else {
        $('.grand-child-container').attr('style', '');
      }
      if (window.innerWidth < 1024 && window.scrollY >= grandChildMenuOffset) {
        $('.grand-child-container').css('margin-top', grandChildMenuHeight);
        grandChildMenu.addClass('grand-child-fixed').css('top', menuHeight + headerHeight);
      } else {
        $('.grand-child-container').css('margin-top', 0);
        grandChildMenu.removeClass('grand-child-fixed').attr('style', '');
      }
    });
  }

  //internal navigation active state
  $(window).on("load scroll", function () {
    let headerHeight = $('header').outerHeight();
    if ($('.video-topics-block').length) {
      let videoBlockHeight = $('.video-topics-block').outerHeight();
      $(document).find('.video-section-container').each(function () {
        let sectionBlock = $(this);
        if (window.scrollY >= ($(this).offset().top - (headerHeight + videoBlockHeight + 120))) {
          $('.video-category-menu').removeClass('active-video-menu');
          $('.video-category-menu').each(function () {
            if (('#' + sectionBlock.attr('id')) == $(this).attr('data-section-id')) {
              $(this).addClass('active-video-menu');
            }
          })
        }
      })
    }
  })

  //sticky navigation for internal menus video page
  let cloned = false;
  $(window).on("load scroll resize", function () {
    setTimeout(function () {
      let headerHeight = $('header').outerHeight(),
        adminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;
      if ($('.video-topics-block').length) {
        let clonedMenu = $('.video-topics-block').clone().addClass('sticky-video-block-active');
        if (!cloned) {
          if (window.scrollY > 300) {
            $('body').append(clonedMenu);
            cloned = true;
          }
        } else if (window.scrollY <= 300) {
          $('html').find('.sticky-video-block-active').remove();
          cloned = false;
        }
        $('html').find('.sticky-video-block-active').css('top', headerHeight + adminBar);
      }
    }, 500);

    // Scroll to section menu link active functionality
    if ($('.static-secondary-menu').length) {
      $('section').each(function () {
        let sectionBlock = $(this),
        headerHeight = $('header').outerHeight(true),
        childMenuHeight = $('.static-secondary-menu').outerHeight(true),
        wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0,
        fairTabs = sectionBlock.find('.curricular-tab').length ? 30 : 0,
        sectionTop = sectionBlock.offset().top,
        sectionMarginTop = parseInt(sectionBlock.css('margin-top')),
        sectionOffset = sectionTop - sectionMarginTop;

        if (window.scrollY >= (sectionOffset - headerHeight - childMenuHeight - wpAdminBar - fairTabs + 20)) {
          $('.static-secondary-menu ul li').removeClass('active');
          $('.static-secondary-menu ul a').each(function () {
            let menuLink = $(this);
            if (sectionBlock.attr('id') == menuLink.attr('data-section-id')) {
              menuLink.parent().addClass('active');
            }
          })
        }
      });
    }
  })

  
  $('#university-acceptance-block .university-tab').on('click', () => {
    const $chartPreview = $('.university-chart-preview');

    if ($chartPreview.hasClass('hidden')) {
      $chartPreview.removeClass('hidden');
    }
  });

})(jQuery, window, document);
